import React, { Component } from 'react';

class Plan extends Component {
    render() {
        const { name, price } = this.props.plan;
        return (
            <div className="card align-self-center m-5 plan-container">
              <div className="card-header font-weight-bold">
                { name }
              </div>
              <div className="card-body">
                <h5 className="card-title">Special title treatment</h5>
                <p className="card-text">At a super low price of { price }.</p>
                <button className="btn btn-primary" 
                   onClick={ this.props.onPlanSelect }>
                    Select Plan
                </button>
              </div>
            </div>
        );
    }
}

export default Plan;